'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  pointer-events: none;\n  z-index: 5;\n'], ['\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  pointer-events: none;\n  z-index: 5;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  max-width: 90vw;\n  border: 1px solid gray;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n  pointer-events: auto;\n'], ['\n  max-width: 90vw;\n  border: 1px solid gray;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n  pointer-events: auto;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 0.7rem;\n  text-align: center;\n  max-width: 75%;\n  padding: 1.5rem;\n  a, a:visited, a:active {\n    color: #0275d8\n  }\n'], ['\n  font-size: 0.7rem;\n  text-align: center;\n  max-width: 75%;\n  padding: 1.5rem;\n  a, a:visited, a:active {\n    color: #0275d8\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _stage = require('../stage/stage');

var _stage2 = _interopRequireDefault(_stage);

var _clock = require('./clock');

var _clock2 = _interopRequireDefault(_clock);

var _paypalButton = require('../entry/paypal-button');

var _paypalButton2 = _interopRequireDefault(_paypalButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var Panel = _styledComponents2.default.div(_templateObject2);

var Terms = _styledComponents2.default.div(_templateObject3);

/** @class Countdown
  * Displays a countdown timer to the show's opening date (if closed),
  * or shows the expo contents.
  * @prop {Date} opens - the date the show opens.  Not required for samples.
  * @prop {Boolean} isSample (default false) - if the show is a sample expo.
  * @prop {Object} stage - the entry stage to use as a background
  * @prop {URLString} logo (optional) - the logo image location.
  */

var Countdown = function (_Component) {
  _inherits(Countdown, _Component);

  function Countdown(props) {
    _classCallCheck(this, Countdown);

    var _this = _possibleConstructorReturn(this, (Countdown.__proto__ || Object.getPrototypeOf(Countdown)).call(this, props));

    _this.state = { open: _this.props.isSample || _this.props.opens - Date.now() < 0 };
    return _this;
  }
  /** @method componentWillMount
    * Checks for special preview access.
    */


  _createClass(Countdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (window.vexpo && window.vexpo.firebase && window.vexpo.firebase.auth().currentUser) {
        var uid = window.vexpo.firebase.auth().currentUser.uid;
        window.vexpo.firebase.database().ref('users/' + uid + '/role').once('value', function (snapshot) {
          if (snapshot.val() === "Admin") _this2.setState({ open: true });
        });
        window.vexpo.firebase.database().ref();
      }
    }
    /** @method render
      * Renders the countdown if the show is not
      * yet open, or the show if it is.
      */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (this.state.open) return this.props.children;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          Wrapper,
          null,
          _react2.default.createElement(
            Panel,
            null,
            _react2.default.createElement('img', { src: this.props.logo, alt: 'logo' }),
            'OPENS IN:',
            _react2.default.createElement(_clock2.default, { opens: this.props.opens, onOpen: function onOpen() {
                return _this3.setState({ open: true });
              } }),
            _react2.default.createElement(_paypalButton2.default, { expoID: this.props.expoID, showID: this.props.showID }),
            _react2.default.createElement(
              Terms,
              null,
              'The North American Sportshow does not share login information with any business, show exhibitor, or third party. We do not send you ads. See our',
              _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/privacy' },
                ' Privacy Policy '
              ),
              ' and',
              _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/tos' },
                ' Terms of Service '
              ),
              ' for details.'
            )
          )
        ),
        _react2.default.createElement(_stage2.default, this.props.stage)
      );
    }
  }]);

  return Countdown;
}(_react.Component);

exports.default = Countdown;


Countdown.defaultProps = {
  isSample: false
};

Countdown.propTypes = {
  isSample: _propTypes2.default.bool.isRequired,
  opens: _propTypes2.default.number.isRequired,
  stage: _propTypes2.default.object.isRequired,
  logo: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/countdown/countdown.js
// module id = 1350
// module chunks = 0